import React, {useState,useEffect} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso,ProfilActionButton,Loading,DeleteActionButton,ColumDataTableReorganize,CreateListeArticle,useLocalStorage} from "@gull";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import cellEditFactory from 'react-bootstrap-table2-editor';
import axios from 'axios'
import swal from "sweetalert2"
import Moment from 'react-moment';
import { useCookies} from 'react-cookie';
import {scrollXDataTable} from 'app/scrollXDataTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { Modal } from "react-bootstrap";

const useLoad = (module,shopId) => {
    const t = useTranslate();
    const [allListeArticle,setAllListeArticle]=useState([])
    const [sizeDatas,setSizeDatas]=useState(0)
    const [loading,setLoading]=useState(true)
    const [perPage,setPerPage]=useState(50)
    const [currentPage,setCurrentPage] = useState(1)
    const [reloadData,setReloadData] = useState(Date.now())

    let endUrl = module=='erp' ? '' : '/'+shopId

    useEffect(function () {
        (async function() {
            const response  = await axios.get(process.env.REACT_APP_API_URL+"api/wms/article_list/list/"+perPage+"/"+currentPage+endUrl,
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else{
                    setAllListeArticle(response.data.datas)
                    setSizeDatas(response.data.count)
                    setLoading(false)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
            setLoading(false)
        })()
    }, [reloadData])
    
    return [loading,allListeArticle,setAllListeArticle,sizeDatas,setSizeDatas,perPage,setPerPage,currentPage,setCurrentPage,setReloadData]
} 

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columns.length)
    }, [window.screen.width,props.columns.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            remote
            pagination={paginationFactory(props.paginationOptions)}
            onTableChange={ props.handleTableChange }
            noDataIndication={t('tableNoData')}
            cellEdit={ cellEditFactory({ 
                mode: 'dbclick', 
                blurToSave: true,
            }) }
            defaultSortDirection={props.defaultSortDirection}
            hover
            condensed
            responsive
        />
    );
};

const ItemsListTableErpPos = (props) => {
    const t = useTranslate();

    const [loading,allListeArticle,setAllListeArticle,sizeDatas,setSizeDatas,perPage,setPerPage,currentPage,setCurrentPage,setReloadData]=useLoad(props.module,props.shopId)
    

    const [cookies, setCookie] = useCookies(['list_d_article_reorganize']);
    const [localStorage, setLocalStorage] = useLocalStorage(['list_d_article_reorganize']);
    useEffect(() => {//ce use effect permet de faire la transistion entre l'ancienne utilisation des cookies pour la gestion des datatable et la nouvell gestion via localStorage. Il faudra supprimer cela et l'utilisation des cookies à partir de juin 2026
        if(!localStorage.list_d_article_reorganize && cookies.list_d_article_reorganize){
            setLocalStorage('list_d_article_reorganize',cookies.list_d_article_reorganize);
        }
    }, []);
    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false) 
    const [showModalCreateItemList,setShowModalCreateItemList]=useState(false) 

    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    const deleteListeArticle = async (articleListId) => {
        const response  = await axios.delete(process.env.REACT_APP_API_URL+"api/wms/article_list/"+articleListId
        ).then((response) => {
            let updateList = allListeArticle.filter(value=>value.id!=articleListId)
            setAllListeArticle(updateList)
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
    }

    let datas = new Array
    allListeArticle.forEach((value,ind)=>{

        let obj = {
            name: value.name,
            id:value.id,
            created_at: <Moment format="DD/MM/YYYY">{value.created_at}</Moment>,
            shop: value.section.name,
            section_id: value.section.id,
            action: 
                <span className="d-flex justify-content-between">
                    <ProfilActionButton path={props.module=='erp' ? '/erp/items-list-detail/'+value.id : '/pos/'+props.shopId+'/items-list/'+value.id}/> 
                    <DeleteActionButton deleteFunctionArgument={value.id} actionType={'typeDeleteX'} nameType={'delete'} toDelete={value.name} customClickEvent={deleteListeArticle}/>
                </span>,
            index:ind
        }
        datas.push(obj)
    })

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        page:currentPage,
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: sizeDatas
    };

    const editItemsList = async (row,field,newValue,done) => {
        const response  = await axios.put(process.env.REACT_APP_API_URL+"api/wms/article_list/"+row.id,{
            [field]:newValue,
            section:row.section_id
        }).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach((interm)=>{
                    let finalMessage=interm.split('/!');
                    if(finalMessage.length==2){
                        messageError+=t(finalMessage[0],{name:finalMessage[1]})+','
                    }
                    else{
                        messageError+=t(interm)+','
                    }
                })
                messageError=messageError.replace('undefined','');
                return done({
                    valid: false,
                    message: t(messageError)
                });
            }
            else{
                return done()
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError = (error.response && error.response.status==403) ? t('forbiddenGeneral') : t('unknowError')
            return done({
                valid: false,
                message: messageError
            });            
        })
    }

    let columns = [
        {
            dataField: "action",
            text: 'Actions',
            editable: false,
        },
        {
            dataField: "name",
            text: t('tableName')+'*',
            editable: true,
            sort: false,
            validator : (newValue, row, column, done) => {
                editItemsList(row,column.dataField,newValue,done)
            }
        },
        {
            dataField: "created_at",
            text: t('createdAt'),
            editable: false,
            sort: false,
        },
        {
            dataField: "shop",
            text: t('shop'),
            editable: false,
            sort: false,
        },
    ];

    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.list_d_article_reorganize){
            let newValueToIncludeInCookie
            let cookieLecture = localStorage.list_d_article_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{
                columns.map(item=>{
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    newValueToIncludeInCookie=true
                    arrCol.push(item);
                }
            })

            columnCookie = arrCol
            if(newValueToIncludeInCookie==true){ 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage("list_d_article_reorganize",arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [])

    const handleTableChange = async (type, { page, sizePerPage, sortField, sortOrder}) => {

        setPerPage(sizePerPage)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/wms/article_list/list/"+sizePerPage+"/"+page
            ).then((response) => {
                setAllListeArticle(response.data.datas)
                setSizeDatas(response.data.count)
                setCurrentPage(page)
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
    }

    
    if(loading){
        return (<Loading></Loading>);
    }
    return (<>
        <CardPerso header={
            <>{
                t('listOfItems')}&nbsp;&nbsp;
                <button className="btn btn-success btn-sm" onClick={() => setShowModalCreateItemList('createItemsList')}><FontAwesomeIcon icon={faPlus} /></button>
            </>}>
            <Modal show={showModalCreateItemList} onHide={() => setShowModalCreateItemList(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('listOfItems')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CreateListeArticle 
                        module={props.module} 
                        sections={props.sections}//Liste des commerces qui est passé depuis le module ERP
                        shopId={props.shopId}//Id du commerce envoyé depuis le POS
                        setShow={setShowModalCreateItemList} 
                        show={showModalCreateItemList} 
                        setReloadData={setReloadData} 

                        listeArticle={allListeArticle} 
                        setListeArticle={setAllListeArticle} 
                    />
                </Modal.Body>
            </Modal>
            <div className="row mb-3">
                <div className="col-2">
                    <ColumDataTableReorganize 
                        columnOrganize={columnOrganize}
                        setColumnOrganize={setColumnOrganize}
                        setCookie={setLocalStorage}
                        cookieName='list_d_article_reorganize'
                        showColumnOrganize={showColumnOrganize}
                        setShowColumnOrganize={setShowColumnOrganize}
                        btnSwitch={false}//pour affiche ou non le btn swith
                        initSwith={true}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                    />&nbsp;&nbsp;&nbsp;
                </div>
            </div>
            <small>
                <ToolkitProvider
                keyField="index"
                data={datas}
                columns={columnOrganize}
                >
                {(propst) => (
                    <>
                        <div className="position-relative">
                            <CustomDataTable 
                                propst={propst}
                                paginationOptions={paginationOptions}
                                columns={columns}
                                handleTableChange={handleTableChange}
                                defaultSortDirection="asc"
                            />
                        </div>
                    </>
                )}
                </ToolkitProvider>
            </small>
        </CardPerso>
        </>
    );
}

export default ItemsListTableErpPos;
